exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".venue[data-v-9d197768] {\n  font-size: 15px;\n  color: #535353;\n  padding: 0;\n}\n.showtime .first_name[data-v-9d197768] {\n  font-size: 1.133em;\n  color: #2f2f2f;\n  font-weight: 700;\n  font-family: \"Times New Roman\", Times, serif;\n}\n.showtime .last_name[data-v-9d197768] {\n  font-size: 1.133em;\n  color: #2f2f2f;\n  font-weight: 700;\n  font-family: \"Times New Roman\", Times, serif;\n}", ""]);

// exports
